import { DiscountVariant } from '../../Blocks/DiscountVariant.csharp';
import { IPromotionInfo } from '../../Marketing/Promotions/PromotionInfo/IPromotionInfo.csharp';
import { renderInfoLabel } from '../../ReactComponents/InfoLabel/InfoLabel';

interface ProductPageDiscountProps {
    discount: IPromotionInfo;
    discountVariant: DiscountVariant;
}

export const ProductPageDiscount = ({ model: { discount, discountVariant } }: { model: ProductPageDiscountProps }) => {
    return renderInfoLabel(discount, discountVariant);
};
